<template>
  <!-- 客户车辆列表 -->
  <div class="container">
    <div class="car-list-header">
      <UserInfoCell theme="white" :name="userInfo.name" :phone="userInfo.mobile_number"
                    @callback="showUpdateUserPhoneDialog"/>
    </div>
    <div class="car-list-content">
      <!--   空车辆状态   -->
      <div class="empty-box" v-if="!carList.length">
        <Empty>
          <img src="../../stylesheets/images/icon/no-vehicwle-icon.jpg" alt="" slot="icon"/>
          <span slot="desc">
            <span>暂未找到客户车辆</span>
            <span v-if="canAddBaseCar">，</span>
            <span v-if="canAddBaseCar" class="add-base-car-btn" @click="handleOpenAddBaseCarDialog">添加客户车辆</span>
          </span>
        </Empty>
      </div>

      <template v-if="carList.length > 0">
        <div class="car-list-item"
          v-for="item in carList"
          :key="item.id"
          @click="$router.push({ path: '/aftersales/carInfo', query: { carId: item.id, mobile: userInfo.mobile_number } })"
        >
          <div class="car-list-item-title">{{ item.plate_number | text }}</div>
          <div class="car-list-item-desc">车架号: {{ item.vin | text }}</div>
          <div class="car-list-item-desc">车型: {{ item.model_desc | text }}</div>

          <div class="car-list-item-arrow">
            <img src="../../stylesheets/images/right.png" alt=""/>
          </div>
        </div>
        <p v-if="!canAddBaseCar" class="car-list-tip">如需新增车辆，请前往“立新出行DOS系统”添加</p>
        <p v-if="canAddBaseCar" class="car-list-tip">
          <span class="add-base-car-btn" @click="handleOpenAddBaseCarDialog">添加客户车辆</span>
        </p>
      </template>

    </div>

    <UpdateUserPhoneDialog ref="updateUserPhoneDialog" @callback="handleUpdateCallback" />
    <!-- 添加车辆 -->
    <AddBaseCarDialog ref="addBaseCarDialogRef" @success="handleAddBaseCarSuccess" />
  </div>
</template>

<script>
import UserInfoCell from './components/UserInfoCell'
import UpdateUserPhoneDialog from './components/UpdateUserPhoneDialog.vue'
import AddBaseCarDialog from './components/AddBaseCarDialog.vue'
import Empty from './components/Empty'
import mixin from './mixins/index.mixin'
import { traceEventsReport } from '../../common/report'
import authApi from '@/common/auth'

export default {
  mixins: [mixin],
  components: { Empty, UpdateUserPhoneDialog, UserInfoCell, AddBaseCarDialog },
  data() {
    return {
      canAddBaseCar: false
    }
  },
  methods: {
    showUpdateUserPhoneDialog() {
      this.$refs.updateUserPhoneDialog.show()
      //  更变用户信息按钮，  弹窗渲染成功上报
      this.$nextTick(async () => {
        const traceFields = await this.getCommonTraceFields()
        traceEventsReport('2-2-2-1-0-0', [{
          ...traceFields,
          page_id: this.$route.meta.eventTrackName
        }])
      })
    },
    async handleUpdateCallback(data) {
      if (!(await this.updateExternalUserInfo(data))) return
      this.$refs.updateUserPhoneDialog.hide()
      // 更改用户信息成功，上报埋点数据
      const traceFields = await this.getCommonTraceFields()
      traceEventsReport('2-2-2-1-1-0', [{
        ...traceFields,
        page_id: this.$route.meta.eventTrackName,
        mobile_number: data.mobile_number
      }])
      // handleToCarPage 返回 false 表示 列表页数据刷新（算一个PV)
      const hasJump = this.handleToCarPage()
      !hasJump && this.pageInitTrace(this.$route.meta.eventTrackName)
    },
    // 车辆列表页渲染成功上报埋点数据
    async pageInitTrace(pageId) {
      const traceFields = await this.getCommonTraceFields()
      traceEventsReport('2-2-2-0-0-0', [{
        ...traceFields,
        page_id: pageId
      }])
    },
    handleOpenAddBaseCarDialog() {
      this.$refs.addBaseCarDialogRef.open()
    },
    handleAddBaseCarSuccess() {
      this.GET_USER_CAR_LIST(this.userInfo.id)
    }
  },
  created() {
    this.getInitData()

    this.$store.state.promiseAuth.then(auth => {
      this.canAddBaseCar = authApi.haveSomeAuth([authApi.aftersales.base_car_add], auth.authList)
    })
  },
  mounted() {
    // 车辆列表页渲染成功上报埋点数据
    this.$nextTick(() => this.pageInitTrace(this.sourcePage))
  },
  filters: {
    text(val) {
      return val || '--'
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../stylesheets/base/variable/global.less';

@w2: 75rem;
.container {
  display: flex;
  flex-direction: column;

  .car-list-header {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;

    &::after {
      position: absolute;
      content: '';
      left: 0;
      top: 0;
      right: 0;
      height: 300/@w2;
      background: #3975C6;
      z-index: -1;
    }
  }

  .car-list-content {
    flex: 1;
    background: #EEEEEE;
    border-radius: 24/@w2 24/@w2 0 0;
    position: relative;
    padding: 35/@w2 30/@w2 0;
    overflow-y: scroll;

    .car-list-item {
      margin-bottom: 24/@w2;
      padding: 30/@w2;
      background: #fff;
      border-radius: 16/@w2;
      position: relative;

      .car-list-item-title {
        font-size: 38/@w2;
        font-weight: bold;
        color: #333;
        line-height: 53/@w2;
        margin-bottom: 16/@w2;
      }

      .car-list-item-desc {
        margin-top: 10/@w2;
        font-size: 28/@w2;
        color: #999;
        line-height: 34/@w2;
      }

      .car-list-item-arrow {
        position: absolute;
        right: 30/@w2;
        top: 50%;
        transform: translateY(-50%);
        width: 30/@w2;
        height: 30/@w2;
      }
    }

    .car-list-tip {
      font-size: 24/@w2;
      color: #999;
      padding: 0 0 24/@w2;
      text-align: center;
    }
  }

  .empty-box {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;

    /deep/ .empty-container {
      position: relative;
      top: -100/@w2;
    }

    /deep/ .empty-desc {
      font-size: 30/@w2;
    }
  }

  .add-base-car-btn {
    color: @color;
    cursor: pointer;
    font-size: 30/@w2;
  }
}
</style>
